import { call, put } from 'redux-saga/effects';
import { setUserDetails } from '../account/accountSlice';
import {
  requestSaveFnoActivationData,
  requestSetuVerification,
  requestSetuVerificationStatus,
} from './fnoActivationFormRequests';
import {
  setFnoActivationFormError,
  setFnoActivationFormStatus,
  setFnoActivationData,
  setFnoSkipped,
  setSetuVerificationDetails,
  setSetuVerificationStatus,
} from './fnoActivationFormSlice';

export function* handleSaveFnoActivationData(action:any): Generator<any, any, any> {
  yield put(setFnoActivationFormStatus('loading'));

  try {
    const response = yield call(
      requestSaveFnoActivationData,
      action.payload.skip ? { skip: true }
        : {
          document_type: action.payload.documentName,
          proof_of_income: action.payload.fileData,
          password: action.payload.password,
        }
    );
    const { data } = response;

    if (data.message) {
      if (action.payload.skip) {
        yield put(setFnoSkipped(true));
      } else {
        yield put(setFnoActivationData(action.payload));
      }
      yield put(setUserDetails(data.user));
    }
  } catch (error: any) {
    yield put(setFnoActivationFormError({
      isError: true,
      type: 'save_fno_details',
      message: error?.response?.data?.message,
    }));
  }
}

export function* handleSetuVerification(): Generator<any, any, any> {
  yield put(setFnoActivationFormStatus('loading'));

  try {
    const response = yield call(
      requestSetuVerification,
      { account_aggregator_flow: true }
    );
    const { data } = response;
    if (response.status === 200) {
      if (data.redirectionUrl) {
        yield put(setSetuVerificationDetails(data));
      }
    } else {
      yield put(setFnoActivationFormError({
        isError: true,
        type: 'save_fno_details',
        message: 'Redirection error, Try again',
      }));
    }
  } catch (error: any) {
    yield put(setFnoActivationFormError({
      isError: true,
      type: 'save_fno_details',
      message: error?.response?.data?.message,
    }));
  }
}

export function* handleSetuVerificationStatus(action:any): Generator<any, any, any> {
  yield put(setFnoActivationFormStatus('loading'));

  try {
    const response = yield call(
      requestSetuVerificationStatus,
      { consentId: action.payload.consentId }
    );
    const { data } = response;
    if (response.status === 200) {
      yield put(setSetuVerificationStatus({
        status: data.consentStatus,
        isSetuVerificationDone: data.consentStatus === "success",
        message: data.message,
      }));
    } else {
      yield put(setFnoActivationFormError({
        isError: true,
        type: 'save_fno_details',
        message: 'Redirection error, Try again',
      }));
    }
  } catch (error: any) {
    yield put(setFnoActivationFormError({
      isError: true,
      type: 'save_fno_details',
      message: error?.response?.data?.message,
    }));
  }
}

export default {};
